import React, { useContext, useMemo } from 'react';

import DropdownButton from 'components/DropdownButton';
import UserContext from 'components/UserContext';

import styles from './styles.module.css';

const ShareToButton = ({
  disabled,
  onShareTooltipClick,
  onTutoringTooltipClick
}) => {
  const { user } = useContext(UserContext);

  const showMeetingOption = useMemo(
    () => !user.is_ui_v2_user,
    [user.is_ui_v2_user]
  );

  return (
    <DropdownButton
      color="blue"
      title="Share To"
      disabled={disabled}
      className={styles.sameWidth}
    >
      {showMeetingOption && (
        <DropdownButton.Item
          onClick={onShareTooltipClick}
          color="blue"
          className={styles.sameWidth}
        >
          Meeting
        </DropdownButton.Item>
      )}
      <DropdownButton.Item
        onClick={onTutoringTooltipClick}
        color="blue"
        className={styles.sameWidth}
      >
        Small Group
      </DropdownButton.Item>
    </DropdownButton>
  );
};

export default React.memo(ShareToButton);
